module.exports = __webpack_public_path__ + "static/turbines-98b318cdadab44a5dd71d9522afef8bb.jpg";